import { Box, Flex, Text } from '@chakra-ui/react';

import LeftIndent from '../../../components/LeftIndent';
import RightIndent from '../../../components/RightIndent';

export interface FormatProperties {
  selectedAlignemnt: string;
  handleAlignemntChange: (event: any) => void;
}

const RowIndentation = ({ handleAlignemntChange, selectedAlignemnt }: FormatProperties) => {
  const handleChange = (style: string) => {
    if (selectedAlignemnt === style) {
      handleAlignemntChange('');
    } else {
      handleAlignemntChange(style);
    }
  };
  const BUTTON_STYLE = {
    width: '29px',
    height: '29px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    cursor: 'pointer',
  };
  return (
    <Flex alignItems={'center'} justifyContent={'space-between'}>
      <Text fontFamily='Roboto Regular' fontWeight='500' fontSize='13px' color='#121826'>
        Indent
      </Text>
      <Flex gap='4px'>
        <Box
          {...BUTTON_STYLE}
          bg={selectedAlignemnt === 'left' ? '#8B5CF6' : '#F5F0FF'}
          onClick={() => handleChange('left')}
        >
          <LeftIndent color={selectedAlignemnt === 'left' ? '#fff' : '#121826'} />
        </Box>
        <Box
          {...BUTTON_STYLE}
          bg={selectedAlignemnt === 'right' ? '#8B5CF6' : '#F5F0FF'}
          onClick={() => handleChange('right')}
        >
          <RightIndent color={selectedAlignemnt === 'right' ? '#fff' : '#121826'} />
        </Box>
      </Flex>
    </Flex>
  );
};
export default RowIndentation;
